var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.922 10v4.249a1.84 1.84 0 01-1.834 1.834H17M13 21.005v-8.223a.92.92 0 01.917-.917H18M19.11 16.083v4.922M17.703 21.005h2.813",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.734 21.281H4.406A1.406 1.406 0 013 19.875V4.406A1.406 1.406 0 014.406 3h9.965c.373 0 .73.148.994.412l2.692 2.692c.264.264.412.621.412.994v2.23",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.5a.5.5 0 000-1v1zm-4.5 4a.5.5 0 000-1v1zm0 5a.5.5 0 000-1v1zM5 8.5h9v-1H5v1zm.41 4H9.5v-1H5.41v1zm0 5H9.5v-1H5.41v1z",
    fill: "currentColor"
  })));
}
export default SvgTableReport;